export const RANK_STATUS = 'RANK_STATUS'
